// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ob2I","colBig":"styles_colBig__37v18","colSmall":"styles_colSmall__tRz36","shopifyNameWrapper":"styles_shopifyNameWrapper__dP9He"};